import getType from"./getType";export function isFormData(payload){return getType(payload)==="FormData"}export default isFormData;